export default ({ percentage }) => ({
    get strokeDashoffset() {
        return this.circumference - (percentage / 100) * this.circumference;
    },
    get circumference() {
        return 50 * 2 * Math.PI;
    },
});
